﻿var $ = require('jquery');
$(".login--selector").click(function(){
    $(".country--dropdown").hide();
    $(".login--dropdown").toggle();
    $(".login--selector").toggleClass("open-d-down");
   var hasarrowdown= $('.btn-red i').hasClass('fa-angle-down');
   if(hasarrowdown)
   {
    $('.btn-red i').removeClass('fa-angle-down');
    $('.btn-red i').addClass('fa-angle-up');
   }
   else{
    $('.btn-red i').removeClass('fa-angle-up');
    $('.btn-red i').addClass('fa-angle-down');
   }
    $(".est-btn-d-down").toggleClass("est-btn-d-down-show")});